import { useEffect, useState } from "react";
import { fetchMyRoles } from "@/lovable-demo/lib/governance/roles";
import {
  permissionsForRoles,
  type AppRole,
  type Permission,
} from "@/lovable-demo/lib/governance/types";
import { supabase } from "@/lovable-demo/runtime/client";

/**
 * Read-only simulated authority for the active synthetic persona.
 * Portal authentication and permissions are not changed by this hook.
 */
export function usePermissions() {
  const [roles, setRoles] = useState<AppRole[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    const load = () => {
      void fetchMyRoles()
        .then((r) => {
          if (alive) setRoles(r);
        })
        .catch(() => {
          if (alive) setRoles([]);
        })
        .finally(() => {
          if (alive) setLoading(false);
        });
    };
    load();
    const { data } = supabase.auth.onAuthStateChange(load);
    return () => {
      alive = false;
      data.subscription.unsubscribe();
    };
  }, []);

  const permissions = permissionsForRoles(roles);
  return {
    roles,
    permissions,
    loading,
    can: (p: Permission) => permissions.includes(p),
  };
}
